import React from "react"
import NavBar from "./general/nav_bar"
import Footer from "./general/footer"
import MainSupportSection from "./general/support.js/main_support_section"

export default function Support(){

    return(
        <>
            <MainSupportSection/>
        </>
    )
}